/**
 * 画布页面菜单
 */
import React, { useState, useContext, memo, useEffect, useMemo } from 'react';
import { Tab, Button, Balloon } from '@alifd/next';
import CanvasUtil from '@/components/canvas/CONSTANT';
import CrowdNumDialog from '../CrowdNumDialog';
import CrowdEffectNumDialog from '../CrowdEffectNumDialog';
import UpGradeImg from '@/assets/images/CanvasImages/upgrade.svg';
import NewImg from '@/assets/images/CanvasImages/new.svg';
import nodes from '../../Nodes';
import styles from './index.module.scss';
import { CanvasService } from '@/service';
import { ActivityContext, PageType } from '../../index';
import UUID from '@/utils/UUID';
import { store } from '@ice/stark-data';

// useTemplate 应用模板数据的方法
const Menu = ({useTemplate}) => {
  // 判断当前商家是不是vip尊享版商家，如果是，不限制操作节点数，不是则只能操作10个
  const [isVipDialog, setVipDialog] = useState(false);
  // 判断是否开通了消息盒子
  const [isMsgBoxWhite, setMsgBoxWhite] = useState(false); // 优惠促销是否开白默认false
//   const [isCrowdEffect, setIsCrowdEffect] = useState(false); // 人群包分析新 是否有能力使用

  // 非vip提供跳转开通的路径
  const linkTo = () => {
    window.open(
      'https://fw.jd.com/main/detail/FW_GOODS-737403?p=fw&t=pcsearch'
    );
  };
  // 关闭vip引导弹窗
  const closedialog = () => {
    setVipDialog(false);
    store.set('isVipDialog', false);
  };
  // 拖拽开始时，会先判断人群节点是否超出150的限制，提示弹窗flag
  const [crowdNodeNumDialog, setCrowdNodeNumDialog] = useState(false);
  // 拖拽开始时，会先判断人群分析节点是否超出10的限制，提示弹窗flag
  const [crowdEffectNodeNumDialog, setCrowdEffectNodeNumDialog] = useState(false);

  const {
    powerInfo,
    pageInfo,
    activityInfo,
    canvasInfo,
    isRichMsg,
    graph,
    nodeData,
    getAllNodes,
    automaticOpenNode,
    strategyNodeNumBeyond,
    crowdEffectNodeNumBeyond
  } = useContext(ActivityContext);
  /**
   * 一下逻辑用于处理在节点菜单中拖拽节点到画布中的逻辑
   */
  // 被拖拽元素的位置
  const [dragPos, setDragPos] = useState({
    x: -9999,
    y: -9999,
  });
  // 被拖拽的节点信息
  const [dragNode, setDragNode] = useState();

  /**
   * 拖拽开始
   * @param node 被拖拽的节点
   */

  const dragStart = async (node) => {
    // 此功能针对不同用户，权限不同，普通用户只能绘制10个节点
    // if (getAllNodes().length > 10) {
    //   if (powerInfo) {
    //   } else {
    //     setVipDialog(true);
    //     return;
    //   }
    // }
    // 在编辑页面允许页面拖拽
    if (pageInfo.type === PageType.editor) {
    //   const {data} = await CanvasService.canvasCrowdEffectCount().catch((e) => {
    //     console.log(e);
    //   });
      const nameAr = ['CROWD_DIG_BATCH', 'CROWD_DIG'];
    //   const lenAr = ['MARKETING_CROWD_BEHAVIOR_ANALYSIS'];
      const nameTag = (strategyNodeNumBeyond() < 150 && nameAr.indexOf(node.info.name) > -1) || nameAr.indexOf(node.info.name) === -1;
    //   const lenTag = ((crowdEffectNodeNumBeyond() + data?.count) < 10 && lenAr.indexOf(node.info.name) > -1) || lenAr.indexOf(node.info.name) === -1;

      // 人群选择节点不能超过150个，等于150时也不能拖进来了，这样会变成151
      if (nameTag) { // && lenTag
        // 将被拖拽节点设置为正在拖拽中的节点
        setDragNode(node);
        // 绑定鼠标移动事件
        const pos = {
          x: -9999,
          y: -9999,
        };
        document.onmousemove = (event) => {
          // 鼠标移动时修改拖拽元素的位置
          // 由于跟随元素使用的fixed定位，所以这个位置获取的坐标是clientX和clientY
          pos.x = event.clientX;
          pos.y = event.clientY;
          setDragPos({ ...pos });
        };
        // 鼠标up或者鼠标离开结束拖拽
        document.onmouseup = (event) => dragStop(event, node);
        document.onmouseleave = (event) => dragStop(event, node);
      } else if (!nameTag) {
        setCrowdNodeNumDialog(true);
      }
    //   else if (!lenTag) {
    //     setCrowdEffectNodeNumDialog(true);
    //   }
    }
  };

  /**
   * 拖拽结束事件
   */
  const dragStop = (event, node) => {
    node.info.fillComplete = false;
    // 移除document上的事件绑定
    document.onmousemove = null;
    document.onmouseup = null;
    document.onmouseleave = null;
    // 将节点添加到画布中
    // x方向 菜单宽350 间隙20 外边距20 共390
    // Y方向 header 60 间隙20 菜单 50 外边句20 共150
    // 如果不满足这个判断条件说明拖拽结束位置不在画布区域
    // 由于这个位置的坐标计算是从页面的最左上角开始逐步计算的所以获取坐标的时候使用的是pageX和pageY
    const x = event.pageX - 390;
    const y = event.pageY - 150;
    // 拖拽结束的点需要在画布区域内
    if (
      x > 0 &&
      x < canvasInfo.size.width &&
      y > 0 &&
      y < canvasInfo.size.height
    ) {
      // 平台专业版以下的商家，不能使用咚咚消息，打开引导页面
      if(JSON.parse(localStorage.getItem('LZ_CURRENT_SHOP'))?.versionNo <= 4 && node.info.label === '咚咚消息') {
        // 获取window域名
        window.open(`${window.location.origin}/guide?menuId=1000051&v=5`);
      } else {
        // 注：此处不可以使用dragNode和dragPos，此处如果使用dragNode/dragPos会获取到null/{x: -9999, y: -9999,}
        // 生成节点的id，格式是 node + 时间戳，这个有可能会更改
        const nodeId = UUID.getUUID32(); // `${node.info.name}_${Date.now()}`;
        // 在节点数据中添加节点信息，
        // TODO: 节点信息的记录位置可以在考虑一下，在这个地方记录涉及到增删节点的时候与graph的数据同步的额外操作，
        // TODO: 但是如果把这个数据放到graph里面又不方便组件读取相关数据，而且会污染Graph封装的逻辑，小纠结
        // if (!strategyNodeNumBeyond()) {
        nodeData.push({
          nodeId,
          ...node.create(),
        });
        graph.addNode(nodeId, node, event.clientX, event.clientY);

        // }
        // “人群批量选择节点”拖拽进入之后默认打开弹窗，因“人群批量选择节点”的特殊性
        // 该节点不属于真正的节点，而是用来批量生成人群的一个节点，不参与连接、填写信息、校验等
        // 拖拽后直接打开弹窗，目的为控制该节点用完即在画布中消失(通过弹窗确认取消按钮的逻辑)
        if (node.info.name === 'CROWD_DIG_BATCH' || node.info.name === 'CROWD_DIG') {
            automaticOpenNode(nodeId);
        }
        if(node.info.name === 'CROWD_SPLIT_2') {
            automaticOpenNode(nodeId, 'CROWD_SPLIT_2');
        }
      }
    }
    // 清理缓存的拖拽中节点
    setDragNode(null);
    // 将节点位置移动到可视区域外
    setDragPos({
      x: -9999,
      y: -9999,
    });
  };

  const [batchSmsPower, setBatchSmsPower] = useState(false);
  const shopId = JSON.parse(localStorage.getItem('LZ_CURRENT_SHOP'))?.shopId;
  const getBatchSmsPower = async () => {
    let param = {
        listKey: 'bulk_sms_sending',
        listType: 1 //1白名单 0黑名单
    }
    await CanvasService.getCanvasPower(param).then(res => {
        const getWhiteListArr = res.data;
        const inWhiteList = getWhiteListArr.includes(Number(shopId)); //当前shopId是否在白名单当中
        setBatchSmsPower(inWhiteList);
    }).catch(e => {
        console.log(e);
    })
  };

  useEffect(() => {
    // CanvasService.getSalesWhiteList()
    //   .then((res) => {
    //     setMsgBoxWhite(res.data);
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
      // 20250410, 线上逻辑优化, 去掉画布中关于人群分析（新）任务数的校验 worktile#174721
    // CanvasService.canvasCrowdEffectCount()
    //     .then((res) => {
    //         setIsCrowdEffect(res.data?.canCreateNewTask);
    //     })
    //     .catch((e) => {
    //         console.log(e);
    //     });
    // 获取系统模板
    // CanvasService.getCanvasSystemTemplate()
    //   .then((res) => { setCommonTemplate(res.data) })
    //   .catch((e) => {
    //     console.log(e);
    //   });

    // getBatchSmsPower();
  }, []);

  useEffect(() => {
    setVipDialog(store.get('isVipDialog'));
  }, [store.get('isVipDialog')]);

  // 判断是否为循环活动,因为此时优惠促销、富信、人群包分析、批量短信、咚咚消息功能禁用；判断是否开通优惠促销功能，未开通也禁用，还有就是其它几个禁用节点的禁用情况
  const canNotNode = ['短信批量发送', '优惠促销', '富信(旧)', '富信', '人群包分析', '人群包分析(新)', '咚咚消息'];
  const checkLoopTypeAndSale = (node) => {
    return (!isMsgBoxWhite && node.info.label === '优惠促销') || (node.info.label === '富信(旧)') || (!isRichMsg && node.info.label === '富信') || (activityInfo.executionPlan?.type === 2 && canNotNode.indexOf(node.info.label) > -1); // || (!isCrowdEffect && node.info.label === '人群包分析(新)')
  };

  // title下划线颜色
  const baseColor = ['#917FFB', '#F9A178', '#75B7FA', '#FF9391'];
  const headerBottom = type => {
    const obj = {
      sourceNodes: baseColor[0],
      operationNodes: baseColor[1],
      taskNodes: baseColor[2],
    //   interestNodes: baseColor[3],
    };
    return obj[type];
  }

  const [currentTabKey, setCurrentTabKey] = useState('1');
  const [commonTemplate, setCommonTemplate] = useState([]); // 通用模板数据
  // 任务节点tab
  const NodeComponents = () => {
    return <>
      {Object.keys(nodes).map((type) => (
        <div className={styles['menu-block']} key={`menu-block-${type}`}>
          <header className={styles['menu-block-header']}>
            <div>
              {
                {
                  sourceNodes: '人群获取',
                  operationNodes: '人群操作',
                  taskNodes: '营销触点',
                //   interestNodes: '客户权益',
                  effectAnalysisNodes:'效果分析',
                }[type]
              }
            </div>
            <div style={{width: 57, height: 3, backgroundColor: `${headerBottom(type)}`, marginTop: -5}}></div>
          </header>
          <div className={styles['node-list']}>
            {nodes[type].map((node) => (<>
                {
                    (node.info.name === 'BATCH_SMS' && batchSmsPower || node.info.name !== 'BATCH_SMS') ?
                    <div
                      style={{position: 'relative'}}
                      className={`${styles[
                        `menu-item-${['source', 'operation', 'task', 'interest'][node.info.type - 1]}`
                      ]}`}
                      key={`node-menu-item-${node.info.name}`}
                      // onClick={
                      //   activityInfo.executionPlan?.type === 2 &&
                      //     node.info.label === '优惠促销'
                      //     ? () => { }
                      //     : () => dragStart(node)
                      // }
                      // onMouseDown={checkLoopTypeAndSale(node) ? () => { } : () => dragStart(node)}
                      onMouseDown={() => {
                        if (!checkLoopTypeAndSale(node)) {
                          dragStart(node);
                        }
                      }}
                    // onClick={() => addNode(node)}
                    >
                      <Balloon.Tooltip
                        align="br"
                        trigger={
                          //   <p
                          //   style={{
                          //     color: checkLoopTypeAndSale(node) ? '#e3e8ee' : '',
                          //     backgroundColor: checkLoopTypeAndSale(node) ? '#f5f7f9' : '',
                          //   }}
                          //   className={`iconfont ${node.info.icon} ${styles['node-icon']}`}
                          // />
                          <img src={node.info.iconText} alt="" />
                        }
                        closable={false}
                      >
                        <div style={{ lineHeight: '20px' }}>
                          {node.info.desc}
                        </div>
                      </Balloon.Tooltip>
                      <p
                        style={{
                          color: checkLoopTypeAndSale(node) ? '#c3cbd6' : '',
                        }}
                        className={styles['node-label']}
                      >
                        {node.info.label}
                      </p>
                      {node.info.label === '优惠促销' && !isMsgBoxWhite && (
                        <div
                          style={{
                            position: 'absolute',
                            top: -3,
                            right: 2,
                            backgroundColor: '#ff3333',
                            color: '#fff',
                            padding: '4px 7px 4px 6px',
                            borderRadius: '14px 8px 7px 0px',
                          }}
                        >
                          未开通
                        </div>
                      )}
                      {/* {['CROWD_DIFFERENCE'].indexOf(node.info.name) > -1 && (
                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                            }}
                        >
                          <img src={UpGradeImg} alt="" style={{width: 47}} />
                        </div>
                      )} */}
                      {/* {['CROWD_INTERSECTION_2', 'CROWD_UNION_2', 'MARKETING_DONGDONG', 'CROWD_SPLIT_2'].indexOf(node.info.name) > -1 && (
                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                            }}
                        >
                          <img src={NewImg} alt="" style={{width: 47}} />
                        </div>
                      )} */}
                    </div> : <></>
                }</>
            ))}
          </div>
        </div>
      ))}
      {dragNode && (
        <div
          className={`iconfont ${styles['drag-node']}`}
          style={{
            left: dragPos.x,
            top: dragPos.y,
            backgroundColor: baseColor[dragNode.info.type - 1]
          }}
        />
      )}
    </>
  }

  // 鼠标移入展示的模板的节点数量
  const [taskDetailList, setTasklist] = useState([]);
  const searchActivityTaskDetail = (item) => {
      const lists = JSON.parse(JSON.stringify(CanvasUtil.nodeType));
      item.forEach((it) => {
          lists.forEach((list) => {
              if (it.resourceType === list.key) {
                  list.value += 1;
              }
          });
      });
      const realList = lists.filter(i => i.value > 0);
      return realList.length > 0 ? <div>
            <div
                style={{ marginTop: 0 }}
                className={`${styles.displayFlex} ${styles.taskNumbers}`}
            >
                <div>节点类型</div>
                <div>数量</div>
            </div>
            <hr />

            <div className={styles.dialogContent}>
                {realList.length &&
                    realList.map(
                        (r, index) =>
                            r.value > 0 && (
                                <div
                                    key={index}
                                    className={`${styles.displayFlex} ${styles.taskNumbers}`}
                                >
                                    <div>{r.name}</div>
                                    <div>{r.value}</div>
                                </div>
                            )
                    )}
            </div>
      </div>
      : <div>暂无节点</div>
  };

  // 模板管理tab
  const TemplateComponents = () => {
    return <div className={styles['template-container']}>
      {
        commonTemplate.map((template, index) => <div>
          <div className={styles['template-classify-name']}>{template.name}</div>
          <div style={{width: 57, height: 3, backgroundColor: `${baseColor[index]}`, marginTop: -5}}></div>
          {
            template?.list.map(templateInfo => <div key={`${templateInfo.id}-${templateInfo.name}`} className={styles['template-name']}>
                <Balloon
                    followTrigger
                    popupStyle={{
                      color: '#333333',
                      borderRadius: '2px',
                      width: '180px',
                    }}
                    align="r"
                    triggerType="hover"
                    trigger={
                        <span>{templateInfo.name}</span>
                    }
                    closable={false}
                    // onVisibleChange={(visible) =>
                    //     visible ? searchActivityTaskDetail(templateInfo.childShapes) : {}
                    // }
                >
                    {searchActivityTaskDetail(templateInfo.childShapes)}
                </Balloon>
                <span className={styles['use-btn']} onClick={() => useTemplate(templateInfo.childShapes)}>应用</span>
            </div>)
          }
        </div>)
      }
    </div>
  }

  // tab所有信息
  const panes = [
    {
      key: '1',
      title: '任务节点',
      desc: (<NodeComponents />),
      tabName: 'nodeTab',
    },
    // {
    //   key: '2',
    //   title: '流程模板',
    //   desc: (<TemplateComponents />),
    //   tabName: 'templateTab',
    //   tip: '应用模板后，请重新确定各个节点的执行时间并保存',
    //   disabled: pageInfo.type !== PageType.editor // 非编辑状态不能点击流程模板
    // },
  ];

  // tab结构
  function CustomTabItem({ title, desc, tabName, tip }) {
    return (
      <div
        className="invite-tabs"
        // onClick={() => {
        //   setCurrentTabKey(tabName);
        // }}
      >
        <div>
          <span className={'next-tabs-tab-inner'} style={{ display: 'inline-block', fontSize: '14px' }}>{title}</span>
          {
            tip && <Balloon.Tooltip
              id="aria-tooltip"
              align="t"
              trigger={
                <span
                  className="iconfont icon-icon4-33"
                  style={{ fontSize: 14, marginLeft: 5 }}
                />
              }
            >
              {tip}
            </Balloon.Tooltip>
          }
        </div>
      </div>
    );
  }

  return (
    <div
      className={`node-menu nodes-Tab ${styles['node-menu']} ${styles[pageInfo.type]}`}
    >
      <Tab
        activeKey={currentTabKey}
        onChange={v => setCurrentTabKey(v)}
        tabRender={(key, props) => <CustomTabItem key={key} {...props} />}
      >
        {
          panes.map((pane) => (
            <Tab.Item
              key={pane.key}
              {...pane}
            >
              {pane.desc}
            </Tab.Item>
          ))
        }
      </Tab>
      <div
        className={styles['vip-dialog']}
        style={{ display: isVipDialog ? 'block' : 'none' }}
      >
        <div className={styles.dialog}>
          <div
            className={`${styles.btnclose} iconfont icon-icon4-29`}
            onClick={closedialog}
          />
          <div className={styles.btn} onClick={linkTo} />
        </div>
      </div>

      {/* 人群选择节点超过150提示弹窗 */}
      {
        crowdNodeNumDialog && <CrowdNumDialog flag={crowdNodeNumDialog} cancelHandel={()=>{
          setCrowdNodeNumDialog(false)
        }}/>
      }
      {/* 人群分析节点超过10提示弹窗 */}
      {
        crowdEffectNodeNumDialog && <CrowdEffectNumDialog flag={crowdEffectNodeNumDialog} cancelHandel={()=>{
          setCrowdEffectNodeNumDialog(false)
        }}/>
      }
    </div>
  );
};
export default memo(Menu);
